import React from 'react';

import {
  Actions as UIActions,
  Action,
  DoneIcon,
  PendingActionsIcon,
  NotInterestedIcon,
  InfoIcon,
  UndoIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

export const Actions = ({
  onUndo,
  onApprove,
  onAddComment,
  onRequestMoreInfo,
  onReject,
  onEdit,
  onDelete,
  onDuplicate,
  withViewLog,
  onViewLog,
  hasComments,
  actions,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => {
        const isAllowDotsMenu =
          isActionAllowed('delete') ||
          isActionAllowed('edit') ||
          isActionAllowed('duplicate') ||
          isActionAllowed('сomment') ||
          isActionAllowed('moreInfo') ||
          isActionAllowed('undo');
        return (
          <UIActions limit={3}>
            <Action
              id={'approve'}
              icon={<DoneIcon />}
              label={'Approve'}
              disabled={!isActionAllowed('approve')}
              onClick={onApprove}
            />
            {withViewLog ? (
              <Action
                id={'viewLog'}
                icon={<PendingActionsIcon />}
                label={'View log'}
                badge={hasComments}
                onClick={onViewLog}
              />
            ) : null}
            <Action
              id={'reject'}
              icon={<NotInterestedIcon />}
              label={'Reject'}
              disabled={!isActionAllowed('reject')}
              onClick={onReject}
            />
            {isAllowDotsMenu && (
              <Action
                id={'more_info'}
                icon={<InfoIcon />}
                label={'Request more info'}
                disabled={!isActionAllowed('moreInfo')}
                onClick={onRequestMoreInfo}
              />
            )}

            {isAllowDotsMenu && isActionAllowed('undo') && (
              <Action>
                <Action
                  id={'undo'}
                  icon={<UndoIcon />}
                  label={'Undo'}
                  onClick={onUndo}
                />
              </Action>
            )}

            {isAllowDotsMenu && (
              <Action>
                <Action
                  id={'comment'}
                  label={'Add comment'}
                  disabled={!isActionAllowed('comment')}
                  onClick={onAddComment}
                />
              </Action>
            )}
            {isAllowDotsMenu && (
              <Action>
                <Action
                  id={'duplicate'}
                  label={'Duplicate'}
                  disabled={!isActionAllowed('duplicate')}
                  onClick={onDuplicate}
                />
                <Action
                  id={'edit'}
                  label={'Edit'}
                  disabled={!isActionAllowed('edit')}
                  onClick={onEdit}
                />
                <Action
                  id={'delete'}
                  label={'Delete'}
                  disabled={!isActionAllowed('delete')}
                  onClick={onDelete}
                />
              </Action>
            )}
          </UIActions>
        );
      }}
    </Permissions>
  );
};

export default Actions;
